import React, { Component } from "react"
import L from "leaflet"
import {
  MAP_GEO_LOCATION,
  MAP_ZOOM,
  MAP_DOM_ID,
  MAP_OPTIONS,
  ICON,
  getMarkerPopupText,
  GROUPED_LOCATION_IDS,
} from "../../configs"
import "leaflet/dist/leaflet.css"

export default class Map extends Component {
  map = null
  isMarkerRendered = false
  locationIdMarkers = {}

  componentDidMount() {
    this.map = L.map(MAP_DOM_ID, MAP_OPTIONS).setView(
      MAP_GEO_LOCATION,
      MAP_ZOOM,
    )

    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
    ).addTo(this.map)
  }

  componentDidUpdate() {
    this.renderMarkersOnce()
    this.showMarker()
  }

  validLocations = () => {
    const { locations } = this.props
    return locations.filter(
      (location) => location.latitude && location.longitude,
    )
  }

  showMarker = () => {
    const { locationIdPopupShown } = this.props
    if (!locationIdPopupShown) return
    const marker = this.locationIdMarkers[locationIdPopupShown]
    if (!marker) return
    marker.openPopup()
  }

  renderMarkersOnce() {
    if (this.isMarkerRendered) return
    const locations = this.validLocations()

    // the grouped locations are on top of each other so instead of
    // rendering two markers on top of each other we merge the markers
    // and their popup message into one marker with one popup.

    const groupedLocations = GROUPED_LOCATION_IDS.map((ids) => {
      return ids.map(
        (id) => locations.filter((location) => location.id === id)[0],
      )
    })

    groupedLocations.forEach((group) => {
      const [location1, location2] = group
      if (!location1 || !location2) return

      // render grouped locations with one marker
      const marker = L.marker([location1.latitude, location1.longitude], {
        icon: ICON,
      }).addTo(this.map)
      marker.bindPopup(
        getMarkerPopupText(location1) + `<hr/>${getMarkerPopupText(location2)}`,
      )

      this.locationIdMarkers[location1.id] = marker
      this.locationIdMarkers[location2.id] = marker
    })

    const remainingLocations = locations.filter(
      (location) => !this.locationIdMarkers.hasOwnProperty(location.id),
    )

    // render regular locations
    for (const location of remainingLocations) {
      const marker = L.marker([location.latitude, location.longitude], {
        icon: ICON,
      }).addTo(this.map)
      marker.bindPopup(getMarkerPopupText(location))
      this.locationIdMarkers[location.id] = marker
    }

    this.isMarkerRendered = true
  }

  render() {
    return <div id={MAP_DOM_ID}></div>
  }
}
